import { CSSProperties } from "react";

export const titleStyle: CSSProperties = {
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '18px'
}

export const subtitleStyle: CSSProperties = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '18px'
}

export const smallStyle: CSSProperties = {
  fontSize: '10px',
  fontWeight: 400,
  lineHeight: '18px'
}

export const skipStyle: CSSProperties = {
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '18px',
  color: '#808080',
  textDecoration: 'italic',
  fontStyle: 'oblique'
}